import { Dispatch } from 'react';
import { History } from 'history';
import { getSipCancelReasons, makeSIPValidation } from '../../../../../redux-store/actions/commercialTransactions';
import { isMobileDevice, OTP_ACTIONS } from '../../../../../utils/constants';
import {
    SipPaths,
    SIPSubmitRequestType,
    SipSummaryObjectType,
    SIPValidateRequestType,
} from '../types';
import { IsAllow } from '../../../../../redux-store/types/portfolio';
import { CommercialRootPath } from '../../routeConfig';
import { sendPhoneOTP } from '../../../../../redux-store/actions/nct';

// generate the common payload for both sip submit and sip validate function in the first function call
const generatePayload = (
    row: SipSummaryObjectType,
    trxnType: 'CSIP' | 'PSIP',
    userTrxnNo: string,
): SIPValidateRequestType => {
    const commonPayload: SIPValidateRequestType = {
        data: [
            {
                amc: row.amc,
                code: '',
                reason: '',
                schemeOptions: [
                    {
                        folio: row.folio,
                        schemeCode: row.schemeCode,
                        userTrxnNo,
                        trxnType,
                        itemNo: '',
                        isin: row.isin,
                        pauseInstallments: '',
                    },
                ],
            },
        ],
    };
    return commonPayload;
};

const isTrxnValid = (
    trxnType: 'CSIP' | 'PSIP',
    isPauseAllowed: IsAllow,
    isCancelAllowed: IsAllow,
) => {
    const pauseValid = trxnType === 'PSIP' && isPauseAllowed === IsAllow.YES;
    const cancelValid = trxnType === 'CSIP' && isCancelAllowed === IsAllow.YES;
    return pauseValid || cancelValid;
};

export const sipValidate =
    (
        row: SipSummaryObjectType,
        dispatch: Dispatch<any>,
        history: History<unknown>,
        setCancelPayload: any,
        setShowReasonDialog: any,
        setRemarks: any,
        setReqId: any,
    ) =>
    async (trxnType: 'CSIP' | 'PSIP') => {
        const sipCancelPayload = generatePayload(row, trxnType, row.userTrxnNo);
        const {
            body: { success, reqId },
        } = await makeSIPValidation(sipCancelPayload)(dispatch);
        if (trxnType === 'CSIP' && success[0].isCancelAllowed === IsAllow.YES) {
            setCancelPayload(sipCancelPayload);
            setRemarks(success[0].remarks)
            setReqId(reqId);
            await getSipCancelReasons(dispatch);
            setShowReasonDialog(true);
        }
        else if (trxnType === 'PSIP' && success[0].isPauseAllowed === IsAllow.YES) {
            try {
                const otpPayload = {
                    reqId,
                    action: OTP_ACTIONS.sipPause,
                };
                const otpRes = await sendPhoneOTP(otpPayload)(dispatch);
                history.push(`${CommercialRootPath}${SipPaths.SipOTP}`, {
                    apiPayload: sipCancelPayload,
                    reqId: otpRes.body.reqId,
                    pauseFlag: trxnType === 'PSIP',
                    otpRef: otpRes.body.otpRef,
                });
            } catch (err: any) {
                throw err;
            }
        } else {
            const errorFromAPI = success[0].remarks;
            if (errorFromAPI) throw new Error(errorFromAPI);

            const errorText = trxnType === 'PSIP' ? 'Pause' : 'Cancel';
            throw new Error(`SIP ${errorText} is not allowed for this scheme`);
        }
    };
